const datasets_params = {
    'task': 'classification',
    'classification_model': 'GPT2',
    'num_labels': 1,
    'num_classes': 2,
    'batch_size': 16,
    'learning_rate_left': 5,
    'learning_rate_right': 3,
    'epochs_num': 3,
    'warmup': 1,
    'dataset_selection': 'hf',
    'dataset_value': 'bla3',
    'metrics': ['precision', 'accuracy', 'recall'],
    'new_model_name': 'my best model2!',
    'client_id': '40b3a00e282ee2db1338c3bba881b99125fc3ba1d7f5c29232ce1ad63fab1e75',
    'model_saved_path': './OPTUNE.ai'
}

export default function get_default_benchmarks_table_data() {
    return [
        {
            key: '0',
            new_dataset_name: 'MMLU',
            created_at: '2024-05-13-10:40:03',
            entries_num: 526525,
            db_size: "359",
            datasets_params: datasets_params,
            category: "Language",
            task: "Language understanding",
            is_external: true,
            tasks_num: 57,
            application: "-",
        },
        {
            key: '1',
            new_dataset_name: 'TruthfulQA',
            created_at: '2023-02-02-11:32:10',
            entries_num: 53691241,
            db_size: "456",
            datasets_params: datasets_params,
            category: "Language",
            task: "Truthfulness",
            is_external: true,
            tasks_num: 26,
            application: "-",
        },
        {
            key: '2',
            new_dataset_name: 'MyChatBot',
            created_at: '2023-03-04-08:15:10',
            entries_num: 92361,
            db_size: "670",
            datasets_params: datasets_params,
            category: "Language",
            task: "Instrcut",
            is_external: false,
            tasks_num: 3,
            application: "Customer Support Chatbot",
        },
    ]
}